import { Box, Grid, Link } from '@mui/material';
import CheckBoxWithLabel from '../../../components/formElements/CheckBoxWithLabel';
import MUIDatePicker from '../../../components/formElements/DatePicker';
import dayjs from 'dayjs';
import InputField from '../../../components/formElements/InputField';
import { MoneyFormatv2 } from '../../../library/MoneyFormat';
import { Button } from 'rsuite';
import { useInvoiceSettings } from '../../InvoiceSettings/hooks/useInvoiceSettings';
import { forwardRef, useEffect, useImperativeHandle } from 'react';

const CompanysetupEway = forwardRef(
  (
    {
      checked,
      disable,
      onEwayChange,
      setUpdatePassword,
      onEinvConnectChange,
      onEinvChange,
      setEInvNotes,
      setEwayNotes,
      ewayUpdatePassword,
      eWayBillBool,
      state,
      setRegularSettings,
      updatePassword,
      linkRef,
      setEwayUpdatePassword,
      handleDateChange,
      companyData,
      settingsBool,
      handleChange,
      usernameRef,
      onEwayConnectChange,
    },
    ref
  ) => {
    console.log('eway render');
    console.log(state, 'llllllllllllllllllllllll');
    const {
      saveChanges: updateInvoiceSettings,
      RegularSettings,
      PosSettings,
      InvoiceSettingsFetching,
    } = useInvoiceSettings({ title: 'set' });
    useEffect(() => {
      setRegularSettings(RegularSettings);
    }, [RegularSettings]);
    useImperativeHandle(ref, () => ({
      settingFn: updateInvoiceSettings,
    }));
    console.log(RegularSettings, 'RegularSettings');
    console.log(settingsBool, 'settingsBool');

    return (
      <Box>
        <Grid container xs={12}>
          <Grid item container xs={12} lg={3}>
            <Box>
              <CheckBoxWithLabel
                checked={checked}
                label="Enable E-way Bill"
                htmlFor="Enable E-way Bill"
                disable={disable}
                onChange={onEwayChange}
              />
            </Box>
          </Grid>
          {eWayBillBool && (
            <Grid item container xs={12} lg={9} spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <MUIDatePicker
                  label="Date of Start"
                  value={state?.formtwo?.ewayBillStartDate !== '' ? dayjs(state?.formtwo?.ewayBillStartDate) : ''}
                  state={state?.formtwo}
                  disable={disable}
                  name="ewayBillStartDate"
                  onChange={(dateValue, context) =>
                    handleDateChange(
                      dateValue,
                      context,
                      'formtwo',
                      'ewayBillStartDate',
                      companyData?.relatedcompanydetailsnew[0]?.EwayBillStartDate
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputField
                  name="eWayBillInterStateAmount"
                  disable={disable}
                  placeholder=" Minimum Amount for E-way Bill Issue(Inter-State)"
                  size="small"
                  type="text"
                  onChange={(event) => handleChange(event, 'formtwo', '', companyData?.relatedcompanydetailsnew[0]?.MinAmountEwayInter)}
                  state={state.formtwo}
                  value={MoneyFormatv2(state?.formtwo?.eWayBillInterStateAmount)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputField
                  name="eWayBillIntraStateAmount"
                  disable={disable}
                  placeholder=" Minimum Amount for E-way Bill Issue(Intra-State)"
                  size="small"
                  onChange={(event) => handleChange(event, 'formtwo', '', companyData?.relatedcompanydetailsnew[0]?.MinAmountEwayIntra)}
                  type="text"
                  state={state.formtwo}
                  value={MoneyFormatv2(state?.formtwo?.eWayBillIntraStateAmount)}
                />
              </Grid>
              {/* <Grid item xs={12} sm={6} md={6} lg={4}></Grid> */}
              <Grid item xs={12} sm={6} md={3} lg={4}>
                <InputField
                  name="ewayusername"
                  disable={disable}
                  placeholder="E-way bill portal User Name"
                  size="small"
                  type="text"
                  inputRef={usernameRef}
                  state={state.formtwo}
                  value={state.formtwo.ewayusername}
                  onChange={(e) => {
                    handleChange(e, 'formtwo', '', state.formtwo.ewayusername);
                  }}
                />

                <CheckBoxWithLabel
                  label="Save & Connect Permanently"
                  id="connect"
                  fontSize={11}
                  disable={disable || state.formtwo.ewayusername == companyData?.ewaybillusername}
                  htmlFor="connect"
                  checked={state.formtwo.ewayconnect}
                  onChange={onEwayConnectChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                {ewayUpdatePassword === false && (
                  <Button
                    id="updatePassword"
                    variant="text"
                    ref={linkRef}
                    disabled={disable}
                    onClick={() => setEwayUpdatePassword(true)}
                    disableRipple={false}
                    sx={{
                      cursor: 'pointer',
                      textDecoration: 'underline',
                    }}
                  >
                    Enter/Update password
                  </Button>
                )}
                {ewayUpdatePassword === true && (
                  <InputField
                    name="ewaypassword"
                    placeholder="E-way bill portal Password"
                    size="small"
                    disable={state.formtwo.ewayusername === ''}
                    type="password"
                    state={state.formtwo}
                    value={state.formtwo.ewaypassword}
                    onChange={(e) => handleChange(e, 'formtwo', '', state.formtwo.ewaypassword)}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                {/* {ewayUpdatePassword === false && ( */}
                <Link
                  id="ewayNotes"
                  variant="text"
                  color="primary"
                  ref={linkRef}
                  disabled={disable}
                  onClick={() => setEwayNotes(true)}
                  disableRipple={false}
                  sx={{
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: '14px',
                  }}
                >
                  Steps to Configure & Generate E-Way Bill
                </Link>
                {/* )} */}
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid container xs={12}>
          {(state?.formtwo?.registrationType == '2' || state?.formtwo?.registrationType == '4') && (
            <>
              <Grid item xs={12} sm={12} md={6} lg={3}>
                <CheckBoxWithLabel
                  label="Enable E-Invoicing"
                  htmlFor="Enable E-Invoicing"
                  disable={disable}
                  checked={state.formtwo.eInvoicing == 1}
                  onChange={onEinvChange}
                />
              </Grid>
              {state?.formtwo?.eInvoicing === 1 && (
                <Grid item container xs={12} lg={9} spacing={2}>
                  <Grid item xs={12} sm={6} md={3} lg={4}>
                    <InputField
                      name="username"
                      placeholder="E-invoice portal User Name"
                      size="small"
                      type="text"
                      disable={disable}
                      inputRef={usernameRef}
                      state={state.formtwo}
                      value={state.formtwo.username}
                      required={state.formtwo.errorStatus.username}
                      //   onBlur={EinvoiceBlur}
                      onChange={(e) => {
                        handleChange(e, 'formtwo', '', state.formtwo.username);
                      }}
                    />
                    <CheckBoxWithLabel
                      label="Save & Connect Permanently"
                      id="connect"
                      htmlFor="connect"
                      fontSize={11}
                      disable={disable || state.formtwo.username == companyData?.einvoiceusername}
                      checked={state.formtwo.connect}
                      onChange={onEinvConnectChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    {updatePassword === false && (
                      <Button
                        id="updatePassword"
                        variant="text"
                        ref={linkRef}
                        disabled={disable}
                        onClick={() => setUpdatePassword(true)}
                        disableRipple={false}
                        sx={{
                          cursor: 'pointer',
                          textDecoration: 'underline',
                        }}
                      >
                        Enter/Update password
                      </Button>
                    )}
                    {updatePassword === true && (
                      <InputField
                        name="password"
                        placeholder="E-invoice portal Password"
                        size="small"
                        disable={state.formtwo.username === ''}
                        type="password"
                        state={state.formtwo}
                        value={state.formtwo.password}
                        // onBlur={EinvoiceBlur}
                        onChange={(e) => handleChange(e, 'formtwo', '', state.formtwo.password)}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    {/* {ewayUpdatePassword === false && ( */}
                    <Link
                      id="ewayNotes"
                      variant="text"
                      color="primary"
                      ref={linkRef}
                      disabled={disable}
                      onClick={() => setEInvNotes(true)}
                      disableRipple={false}
                      sx={{
                        cursor: 'pointer',
                        textDecoration: 'underline',

                        fontSize: '14px',
                      }}
                    >
                      Steps to Configure & Generate E-invoice
                    </Link>
                    {/* )} */}
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </Grid>
      </Box>
    );
  }
);

export default CompanysetupEway;
